/**
 * Resolve organization Mongo ID from the many shapes auth/profile APIs return.
 * Without this, org-scoped user list/invite silently no-ops.
 */
export const resolveOrganizationId = (source) => {
  if (!source || typeof source !== "object") return null;

  const direct =
    source.organizationID ||
    source.organizationId ||
    source.organization?._id ||
    source.organization?.id ||
    null;

  if (typeof direct === "string" && direct.trim()) return direct.trim();
  if (direct && typeof direct === "object") {
    const nested = direct._id || direct.id;
    if (typeof nested === "string" && nested.trim()) return nested.trim();
  }

  const roles = Array.isArray(source.roles) ? source.roles : [];
  for (const role of roles) {
    const org = role?.organizationID || role?.organizationId || role?.organization;
    if (typeof org === "string" && org.trim()) return org.trim();
    if (org && typeof org === "object") {
      const id = org._id || org.id;
      if (typeof id === "string" && id.trim()) return id.trim();
    }
  }

  return null;
};

/** Normalize a role field to a display/API string (handles object roles). */
export const resolveRoleName = (roleOrRoles) => {
  if (Array.isArray(roleOrRoles) && roleOrRoles.length > 0) {
    return resolveRoleName(roleOrRoles[0]);
  }
  if (typeof roleOrRoles === "string" && roleOrRoles.trim()) {
    return roleOrRoles.trim();
  }
  if (roleOrRoles && typeof roleOrRoles === "object") {
    return roleOrRoles.name || roleOrRoles.roleName || roleOrRoles._id || "";
  }
  return "";
};
